import React from "react";
// core components
import { Banner, Promotion } from "organisms";
import { Background } from "atoms";
import { TEXTS } from "../../constants";

import "./styles.scss";

export default class LandingPage extends React.Component {
  render() {
    return (
      <div>
        <Background />
        <Banner
          onButtonClicked={event => {
            window.location.href = TEXTS.APP_URL;
          }}
        />
        <Promotion cards={TEXTS.PROMOTION_CARDS} />
      </div>
    );
  }
}
